import styled from 'styled-components';

export const StyledOrderBySelector = styled('div')`
    .text {
        padding-right: 15px;
    }

    .icon{
        margin-right: 10px;
    }

    .ant-select-item {
        min-width: 142px;
    }

    .ant-select-dropdown-hidden {
        display: none !important;
    }

    .ant-select-selection-item {
        display: none !important;
    }
`;

export const StyledPageSizeSelector = styled('div')`
    .text {
        margin-right: -7px;
    }

    .ant-select {
        .ant-select-arrow {
            width: 20px;
        }
    }

    .ant-select-item {
        min-width: 142px;
    }

    .ant-select-dropdown-hidden {
        display: none !important;
    }
`;

export const StyledTopCategorySelector = styled('div')`
  border: 1px solid ${(props) => props.theme};
  padding: 15px;

  .ant-tooltip {
    display: none;
  }

  .btn {
    max-width: 200px;
    display: flex;
    font-size: 14px;
  }

  .category {
    display: flex;
    flex-direction: column;

    .preview {
      max-width: 500px;
      max-height: 500px;
      margin-bottom: 12px;

      .ant-image {
        width: 467px;
        height: 194px;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
      }

      .ant-image-img {
        width: 100%;
        object-fit: contain;
        object-position: center;
        display: block;
      }
    }

    .ant-upload-list-item-container {
      max-width: 200px;
      overflow: hidden;
    }

    .ant-form-item {
      min-width: 200px;
      max-width: 200px;
      margin-bottom: 0;

      .ant-select-dropdown {
        position: absolute;
        top: 20px;
      }
    }

    .validation-text {
      margin: 12px 0;
    }
  }

  .initial-value {
    color: ${(props) => props.theme.colorText} !important;
  }
`;

export const StyledCategorySelector = styled('div')`
  .drop-down {
      min-width: 245px;
      min-height: 41px;
      max-width: 255px;
  }

  .ant-select-selection-item {
    font-family: ${(props) => props.theme.fontText};
  }

  .ant-select-item-option-content {
    font-family: ${(props) => props.theme.fontText};
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
    min-height: 41px;
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }
  .displayFlex {
    display: flex;
    gap: 10px;
  }
  .admin {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: flex-end;
    gap: 10px;
    font-family: ${(props) => props.theme.fontText};
  }

  .user {
    .drop-down {
      margin-bottom: 20px;
    }
  }
`;

export const StyledLocationSelector = styled('div')`
  margin-bottom: 18px;

  .drop-down {
      min-width: 245px;
      min-height: 41px;
      max-width: 255px;
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }
`;

export const StyledFarmsSelector = styled('div')`
  font-family: ${(props) => props.theme.fontText};
  margin-bottom: 18px; 
    
  .drop-down {
      min-width: 245px;
      min-height: 41px;
      max-width: 255px;
  }

  .form-title {
    padding-top: 0;
  }

  .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }

  :where(.ant-select).ant-select-outlined:not(.ant-select-disabled):not(
      .ant-select-customize-input
    ):not(.ant-pagination-size-changer):hover
    .ant-select-selector {
    border-color: ${(props) => props.theme.borderBottom};
  }
`;
